import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import './index.scss';
import { TooltipPlacement } from '../../../../enums/tooltip';

interface CustomTooltipProps {
    content: React.ReactNode;
    placement?: TooltipPlacement;
    children: JSX.Element;
    wrapperClasses?: string;
    tooltipClasses?: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ 
    content, 
    placement = TooltipPlacement.TOP,
    children,
    wrapperClasses = '',
    tooltipClasses = ''
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div 
            className={`custom-tooltip-wrapper ${wrapperClasses}`} 
            onMouseEnter={handleOpen} 
            onMouseLeave={handleClose}
        >
            <Tooltip
                title={content}
                placement={placement}
                open={open}
                arrow
                disableFocusListener
                disableHoverListener
                disableTouchListener
                classes={{ 
                    tooltip: `custom-tooltip ${tooltipClasses}`, 
                    arrow: 'custom-arrow'
                }}
            >
                {children}
            </Tooltip>
        </div>
    );
};

export default CustomTooltip;